export default __webpack_public_path__ + "static/media/menu-appointment-schedule-icon.e82d640e.svg";